import { clone } from '@jkhy/frontend-utils/functions';
import { WireTransferDliProductFeatureModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: WireTransferDliProductFeatureModelDto = {
    feePerTransaction: 0,
    dailyLimit: 0,
    requirePurpose: false,
    internationalUsd: false,
    useNonCoreInternationalWireCompanies: false,
    allowAccountBalanceValidation: false,
    internationalUsdReadOnly: true,
    showInternationalUsd: true,
    useExternalFxWireProcessing: false,
    id: 0,
    type: 'WireTransferDLI',
    productUniqueId: '',
    isConfigurable: false,
};
export class ForeignCurrencyWireProductFeature extends CompanyProductFeature<WireTransferDliProductFeatureModelDto> {
    constructor(dto: WireTransferDliProductFeatureModelDto = clone(defaultDto)) {
        super(dto);
    }
}
